module.exports = __webpack_public_path__ + "images/insights-board-your-brand-617267d7.svg";